import { AdminUsers } from "../AdminUsers/AdminUsers";

export const AdminUsersSettings = () => {
  return (
    <div className={"flex flex-col w-full h-full p-4"}>
      <AdminUsers />
    </div>
  );
};
